"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChapterTree = void 0;
const Verse_1 = require("./Verse");
const ScriptureTreeObject_1 = require("./ScriptureTreeObject");
class ChapterTree extends ScriptureTreeObject_1.ScriptureTreeObject {
    get book() {
        return this.parent;
    }
    get translation() {
        return this.parent.parent;
    }
    get firstVerse() {
        return new Verse_1.VerseTree(this.data.verses[0], this);
    }
    get lastVerse() {
        return new Verse_1.VerseTree(this.data.verses[this.data.verses.length - 1], this);
    }
    get number() {
        return this.data.number;
    }
    dump() {
        return {
            tid: this.translation.tid,
            bid: this.book.bid,
            number: this.number,
            fromVid: this.firstVerse.fromVid,
            toVid: this.lastVerse.toVid,
            bookName: this.book.name,
            translationName: this.translation.name,
            translationAbbr: this.translation.abbreviation,
        };
    }
    /**
     * Get the labels of all verses in this chapter.
     */
    get verseLabels() {
        return this.data.verses.map((verse) => verse.label);
    }
    /**
     * Get the starting IDs of all verses in this chapter.
     */
    get verseIds() {
        return this.data.verses.map((verse) => verse.fromVid);
    }
    /**
     * Get the starting ids and labels for all verses in this chapter
     */
    get verseIdsAndLabels() {
        return this.data.verses.map((verse) => ({
            vid: verse.fromVid,
            label: verse.label,
        }));
    }
    /**
     * Get a specific verse by label.
     */
    getVerseByLabel(label) {
        const data = this.data.verses.find((verse) => verse.label === label);
        return data ? new Verse_1.VerseTree(data, this) : null;
    }
    /**
     * Get a specific verse by ID.
     */
    getVerseById(vid) {
        const data = this.data.verses.find((verse) => verse.fromVid <= vid && verse.toVid >= vid);
        return data ? new Verse_1.VerseTree(data, this) : null;
    }
    /**
     * Get all verses in this chapter that overlap with the given range of verse IDs.
     */
    getVersesById(fromVid, toVid) {
        // TODO.
        return [];
    }
    *iterateVerses(reverse = false) {
        const it = reverse ? this.data.verses.slice().reverse() : this.data.verses;
        for (const verseData of it) {
            yield new Verse_1.VerseTree(verseData, this);
        }
    }
}
exports.ChapterTree = ChapterTree;
